import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-029df152"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container inner" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = { class: "row" };
const _hoisted_4 = {
    class: "col-md",
    "simply-fade": "right"
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
    class: "col-md",
    "simply-fade": "left"
};
const _hoisted_7 = ["innerHTML"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'two_column_text',
    props: ['d'],
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_smart_text = _resolveComponent("smart-text");
            return (_openBlock(), _createBlock(_component_smart_text, {
                class: "two_column_text",
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", {
                            innerHTML: __props.d.header,
                            class: "mb-4"
                        }, null, 8, _hoisted_2),
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", {
                                    innerHTML: __props.d.left_text
                                }, null, 8, _hoisted_5)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", {
                                    innerHTML: __props.d.right_text
                                }, null, 8, _hoisted_7)
                            ])
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["style"]));
        };
    }
});
